<template>
  <i :class="[icon]" class="text-info" v-tooltip="{
    content: explanation,
  }"></i>
</template>
<script setup>
const props = defineProps({
  explanation: String,
  icon: {
    type: String,
    default: 'icon-notify-info '
  }
})
</script>